module.exports = __webpack_public_path__ + "static/media/todo.7216b867.svg";